export default "__VITE_ASSET__BYuc7EO___"